// ----------------------------------------------------------------------
// <copyright file="Izenda.FlattenTreeUIStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var extendObservable = require('mobx').extendObservable;
  var action = require('mobx').action;
  var asMap = require('mobx').asMap;
  const { filter, memoize, isUndefined } = require('lodash/fp');
  function FlattenTreeUIStore() {
    extendObservable(this, {
      expandedMap: asMap(),
      nodeList: [],
      visibleNodeList: function() {
        var isVisible = (this.memoizeIsVisible = memoize(this.isVisible.bind(this)));
        var result = filter(isVisible, this.nodeList);

        this.memoizeIsVisible = null;
        return result;
      }
    });
  }

  FlattenTreeUIStore.prototype.setNodes = action(function setNodes(nodes) {
    this.nodeList = nodes;
  });

  FlattenTreeUIStore.prototype.toggleCollapsibleOfNode = action(function toggleCollapsible(node) {
    var isExpanded = this.isExpanded(node);
    node.expanded = !isExpanded;
    node.key && this.expandedMap.set(node.key, !isExpanded);
  });

  FlattenTreeUIStore.prototype.isVisible = function(node) {
    var parent = node.parent;
    if (!parent) return true;

    var parentExpanded = this.isExpanded(parent);
    if (!parentExpanded) return false;

    return this.memoizeIsVisible ? this.memoizeIsVisible(parent) : this.isVisible(parent);
  };

  /**
   * Check whether a node is expanded by user action
   * @param  {String}  key Node key
   * @return {Boolean}     True/False/Undefined
   */
  FlattenTreeUIStore.prototype.isExpanded = function(node) {
    // Take expansion user action state of node.
    var userExpanded = this.expandedMap.get(node.key);

    // Whether user didn't interact with current node yet
    var userUndefined = isUndefined(userExpanded);

    // If user didn't interact yet, take expanded value by data.
    // Otherwise, keep latest user action state.
    return userUndefined ? node.expanded : userExpanded;
  };

  module.exports = FlattenTreeUIStore;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/TreeView/Izenda.FlattenTreeUIStore.js